export default "__VITE_ASSET__cbf509d5__"